// extracted by mini-css-extract-plugin
export var activityContainer = "_lz-0";
export var typingIndicatorContainer = "_lz-1";
export var typingIndicatorDot = "_lz-2";
export var wave = "_lz-3";